// #tag: UI AUDIO FEEDBACK HOOK
// #purpose: Synchronizes synthesized Web Audio cues with user interaction settings and provides play/preview triggers.
import { useCallback, useEffect } from 'react';
import { useAppearance } from '../context/AppearanceProvider';
import { playUiSound, preloadUiSounds, setUiSoundConfig, unlockUiSound, type UiSoundEvent } from '../lib/uiSound';

export function useUiSound() {
  const { settings } = useAppearance();

  useEffect(() => {
    setUiSoundConfig({
      enabled: settings.soundEnabled,
      volume: settings.soundVolume / 100,
      respectReducedMotion: settings.respectReducedMotion,
      respectSystemSilent: settings.respectSystemSilent,
      animations: settings.animations,
    });
  }, [
    settings.animations,
    settings.respectReducedMotion,
    settings.respectSystemSilent,
    settings.soundEnabled,
    settings.soundVolume,
  ]);

  useEffect(() => {
    preloadUiSounds();
  }, []);

  const play = useCallback((event: UiSoundEvent) => {
    playUiSound(event);
  }, []);

  const preview = useCallback(
    (event: UiSoundEvent) => {
      unlockUiSound();
      playUiSound(event, { preview: true });
    },
    [],
  );

  return {
    play,
    preview,
    soundEnabled: settings.soundEnabled,
  };
}
